import { ChartConfig } from "./chart.model";

export interface DevicesRequest {
    fabricante: Record<string, ManufacturerRequest>;
}

export interface ManufacturerRequest {
    nombreFabricanteHumanReadable: string;
    numeroDispositivos: number;
    modelos: Record<string, ModelRequest>;
}

export interface ModelRequest {
    iosAndroid: string;
    humanReadableModelName: string;
    numero: number;
    indexOnList: number;
}

export interface DeviceI {
    manufacturer: string;
    totalDevices: number;
    models?: DeviceModelI[];
    date: number;
}

export interface DeviceModelI {
    model: string;
    os: string; // Sistema operativo
    humanModelName: string;
    totalDevices: number;
    modelIndex: number;
}

export const DEVICE_CHART_CONFIG: ChartConfig = {
    type: 'line',
    // yAxis: {},
    xAxis: {
        type: 'datetime',
        dateTimeFormat: {
            day: '%d',
            month: '%b %Y'
        }
    }
};

export const DEVICE_DETAIL_CHART_CONFIG: ChartConfig = {
    type: 'line',
    // yAxis: {},
    xAxis: {
        type: 'datetime',
        dateTimeFormat: {
            day: '%d',
            month: '%b %Y'
        }
    }
};